/**
 * The creatures of the night (ADR 0093): one per biome, out only in the full
 * night (`isNight`). Each haunts the dens of its biome's calm kind, the
 * `sleeper`: at nightfall half of those dens fall asleep and the night
 * creature stands in their place, one for one, and at dawn the sleepers wake
 * again (`MobController`). It fights at the sleeper's measure and leaves its
 * table, so the night changes what one meets, never the pace of a region;
 * but it is never calm. Each has a body of its own (SHE-164).
 * Their stat blocks are derived in `mobs.ts`; only what names them lives
 * here, so `mobs.ts` and `loot.ts` can both read it.
 */
export const NIGHT_MOB_IDS = [
    'midnight-wolf',
    'wood-revenant',
    'bog-drowned',
    'dune-wisp',
    'ice-sleeper',
];
export const NIGHT_MOBS = Object.freeze({
    'midnight-wolf': {
        biome: 'meadow',
        sleeper: 'fox',
        bodyKey: 'body.midnight-wolf',
        name: 'Loup de minuit',
    },
    'wood-revenant': {
        biome: 'forest',
        sleeper: 'treant',
        bodyKey: 'body.wood-revenant',
        name: 'Revenant des bois',
    },
    'bog-drowned': {
        biome: 'swamp',
        sleeper: 'toad',
        bodyKey: 'body.bog-drowned',
        name: 'Noyé des tourbières',
    },
    'dune-wisp': {
        biome: 'desert',
        sleeper: 'scorpion',
        bodyKey: 'body.dune-wisp',
        name: 'Feu des dunes',
    },
    'ice-sleeper': {
        biome: 'snow',
        sleeper: 'polar-bear',
        bodyKey: 'body.ice-sleeper',
        name: 'Gisant des glaces',
    },
});
const NIGHT_IDS = new Set(NIGHT_MOB_IDS);
export function isNightMob(mobId) {
    return NIGHT_IDS.has(mobId);
}
/** The night creature that takes a calm kind's dens in a biome, if one does. */
export function nightMobOf(biome, sleeper) {
    return NIGHT_MOB_IDS.find((id) => NIGHT_MOBS[id].biome === biome && NIGHT_MOBS[id].sleeper === sleeper);
}
//# sourceMappingURL=night-mobs.js.map